import e from "react";
import { X as l } from "@olxbr/ds-icons";
import { VisuallyHidden as a } from "../../../VisuallyHidden/VisuallyHidden.js";
import { Text as r } from "../../../Text/Text.js";
const n = () => e.createElement(l, {
    size: "24",
    color: "var(--color-neutral-130)"
  }),
  m = _ref => {
    let {
      closeCallback: t,
      title: o
    } = _ref;
    return e.createElement("div", {
      className: "olx-modal__topbar"
    }, e.createElement(r.TitleSmall, {
      color: "--color-neutral-130"
    }, o), e.createElement("button", {
      "data-ds-component": "DS-Modal-Button",
      onClick: t,
      type: "button",
      className: "olx-modal__topbar-button"
    }, e.createElement(a, null, "Fechar janela de di\xE1logo"), e.createElement(n, null)));
  };
export { m as TopBar };